exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".trial-notice .sweet-modal.is-alert .sweet-content{padding-bottom:32px}", ""]);

// exports
